import { t } from "i18next"

function templateTranslations() {
    return {
        header: t("template-base-bee-header"),
        desc: t("template-base-bee-desc"),
        block1Header: t(
            "template-base-bee-block1_header"
        ),
        block1Desc: t("template-base-bee-block1_desc"),
        block1Btn: t("template-base-bee-block1_btn"),
        blocksHeader: t(
            "template-base-bee-blocks_header"
        ),
        blocksDesc: t("template-base-bee-blocks_desc"),
        blocksBtn: t("template-base-bee-blocks_btn"),
        blockLastHeader: t(
            "template-base-bee-block_last_header"
        ),
        blockLastDesc: t(
            "template-base-bee-block_last_desc"
        ),
        socialHeader: t(
            "template-base-bee-social_header"
        ),
        linksHeader: t("template-base-bee-links_header"),
        linksLink: t("template-base-bee-links_link"),
        footer1: t("template-base-bee-footer_part1"),
        footer2: t("template-base-bee-footer_part2"),
        footer3: t("template-base-bee-footer_part3"),
        footer4: t("template-base-bee-footer_part4"),
        footer5: t("template-base-bee-footer_part5"),
        footerLink1: t("template-base-bee-footer_link1"),
        footerLink2: t("template-base-bee-footer_link2"),
        footerLink3: t("template-base-bee-footer_link3"),
    }
};

export function getBaseBeeTemplate() {
    const translations = templateTranslations()
    return {
        page: {
            body: {
                container: { style: { "background-color": "#FFFFFF" } },
                content: {
                    computedStyle: {
                        linkColor: "#0000FF",
                        messageBackgroundColor: "transparent",
                        messageWidth: "600px",
                    },
                    style: {
                        color: "#000000",
                        "font-family": "Arial, Helvetica Neue, Helvetica, sans-serif",
                    },
                },
                type: "mailup-bee-page-properties",
                webFonts: [
                    {
                        family:
                            " 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Geneva, Verdana, sans-serif",
                        fontFamily:
                            " 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Geneva, Verdana, sans-serif",
                        fontName: "Lucida Sans",
                        name: "Lucida Sans",
                    },
                    {
                        family: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                        fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                        fontName: "Arial",
                        name: "Arial",
                    },
                ],
            },
            description: "",
            rows: [
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            class: "center fixedwidth",
                                            width: "108px",
                                        },
                                        image: {
                                            alt: "Alternate text",
                                            height: "182px",
                                            href: "",
                                            src: "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/d12425a2-57e5-445b-896d-425ad79fd2ca/851575/cakemail-demo-content-logo%403x.png",
                                            width: "363px",
                                        },
                                        style: {
                                            "padding-bottom": "32px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "60px",
                                            width: "100%",
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-image",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "60px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#09aa9d" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; text-align: center; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word; text-align: center;\"><strong><span style=\"font-size: 30px; line-height: 45px;\" data-mce-style=\"font-size: 30px; line-height: 45px;\">${translations.header}</span></strong></p><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; text-align: center; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word; text-align: center;\">\u00a0</p><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; text-align: center; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word; text-align: center;\"><span style=\"font-size: 18px; line-height: 27px;\" data-mce-style=\"font-size: 18px; line-height: 27px;\">${translations.desc}</span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "60px",
                                "padding-left": "30px",
                                "padding-right": "30px",
                                "padding-top": "60px",
                            },
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "#f8f8f8",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#000000",
                            width: "500px",
                        },
                    },
                    type: "one-column-empty",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            class: "center autowidth",
                                            hideContentOnMobile: false,
                                            width: "540px",
                                        },
                                        image: {
                                            alt: "Alternate text",
                                            height: "1080px",
                                            href: "",
                                            src: "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/d12425a2-57e5-445b-896d-425ad79fd2ca/851575/cakemail-demo-content-feature%402x_1.jpg",
                                            width: "1200px",
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            width: "100%",
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-image",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "60px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 30px; line-height: 45px;\" data-mce-style=\"font-size: 30px; line-height: 45px;\">${translations.block1Header}</span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "32px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 21px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 21px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 25px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 25px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 32px;\" data-mce-style=\"font-size: 18px; line-height: 32px;\">${translations.block1Desc}</span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "180%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        button: {
                                            href: "",
                                            label: `<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 16px; line-height: 32px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 36px;\" data-mce-style=\"font-size: 18px; line-height: 36px;\">${translations.block1Btn}</span></p></div>`,
                                            style: {
                                                "background-color": "#009370",
                                                "border-bottom": "0px solid transparent",
                                                "border-left": "0px solid transparent",
                                                "border-radius": "60px",
                                                "border-right": "0px solid transparent",
                                                "border-top": "0px solid transparent",
                                                color: "#ffffff",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "24px",
                                                "padding-left": "32px",
                                                "padding-right": "32px",
                                                "padding-top": "24px",
                                                width: "auto",
                                            },
                                        },
                                        computedStyle: {
                                            height: 84,
                                            hideContentOnMobile: false,
                                            width: 174,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "32px",
                                            "text-align": "left",
                                        },
                                        text: {
                                            style: {
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-button",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "60px",
                                "padding-left": "30px",
                                "padding-right": "30px",
                                "padding-top": "60px",
                            },
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#000000",
                            width: "500px",
                        },
                    },
                    type: "one-column-empty",
                },
                {
                    columns: [
                        {
                            "grid-columns": 6,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            class: "center fixedwidth fullwidthOnMobile",
                                            width: "240px",
                                        },
                                        image: {
                                            alt: "Alternate text",
                                            height: "548px",
                                            href: "",
                                            src: "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/d12425a2-57e5-445b-896d-425ad79fd2ca/851575/cakemail-demo-content-product-1%402x_1.jpg",
                                            width: "480px",
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            width: "100%",
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-image",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "32px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 22px; line-height: 33px;\" data-mce-style=\"font-size: 22px; line-height: 33px;\">${translations.blocksHeader}</span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnDesktop: false,
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "16px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 27px;\" data-mce-style=\"font-size: 18px; line-height: 27px;\">${translations.blocksDesc}</span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "24px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 27px;\" data-mce-style=\"font-size: 18px; line-height: 27px;\"><a style=\"text-decoration: underline;\" href=\"http://www.cakemail.com\" target=\"_blank\" rel=\"noopener\">${translations.blocksBtn}</a></span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "60px",
                                "padding-left": "30px",
                                "padding-right": "30px",
                                "padding-top": "60px",
                            },
                        },
                        {
                            "grid-columns": 6,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            class: "center fixedwidth fullwidthOnMobile",
                                            width: "240px",
                                        },
                                        image: {
                                            alt: "Alternate text",
                                            height: "548px",
                                            href: "",
                                            src: "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/d12425a2-57e5-445b-896d-425ad79fd2ca/851575/cakemail-demo-content-product-2%402x_1.jpg",
                                            width: "480px",
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            width: "100%",
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-image",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "32px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 22px; line-height: 33px;\" data-mce-style=\"font-size: 22px; line-height: 33px;\">${translations.blocksHeader}</span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "16px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 27px;\" data-mce-style=\"font-size: 18px; line-height: 27px;\">${translations.blocksDesc}</span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "24px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 27px;\" data-mce-style=\"font-size: 18px; line-height: 27px;\"><a style=\"text-decoration: underline;\" href=\"http://www.cakemail.com\" target=\"_blank\" rel=\"noopener\">${translations.blocksBtn}</a></span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "60px",
                                "padding-left": "30px",
                                "padding-right": "30px",
                                "padding-top": "60px",
                            },
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#000000",
                            width: "500px",
                        },
                    },
                    type: "two-columns-empty",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            class: "center autowidth",
                                            hideContentOnMobile: false,
                                            width: "540px",
                                        },
                                        image: {
                                            alt: "Alternate text",
                                            height: "999px",
                                            href: "",
                                            src: "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/d12425a2-57e5-445b-896d-425ad79fd2ca/851575/cakemail-demo-content-article-1%402x_1.jpg",
                                            width: "1200px",
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            width: "100%",
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-image",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "60px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 30px; line-height: 45px;\" data-mce-style=\"font-size: 30px; line-height: 45px;\"><a style=\"text-decoration: underline;\" href=\"http://www.cakemail.com\" target=\"_blank\" rel=\"noopener\">${translations.blockLastHeader}</a></span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "32px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 21px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 21px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 25px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 25px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 32px;\" data-mce-style=\"font-size: 18px; line-height: 32px;\">${translations.blockLastDesc}</span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "180%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "60px",
                                "padding-left": "30px",
                                "padding-right": "30px",
                                "padding-top": "60px",
                            },
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#000000",
                            width: "500px",
                        },
                    },
                    type: "one-column-empty",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "24px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"font-size: 14px; line-height: 21px; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 22px; line-height: 33px;\" data-mce-style=\"font-size: 22px; line-height: 33px;\">${translations.linksHeader}</span></p></div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\">\n<ul style=\"list-style-type: circle;\">\n<li style=\"font-size: 14px; line-height: 21px; word-break: break-word;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 27px;\" data-mce-style=\"font-size: 18px; line-height: 27px;\"><a style=\"text-decoration: underline;\" href=\"http://www.cakemail.com\" target=\"_blank\" rel=\"noopener\">${translations.linksLink}</a></span></li>\n</ul>\n</div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\">\n<ul style=\"list-style-type: circle;\">\n<li style=\"font-size: 14px; line-height: 21px; word-break: break-word;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 27px;\" data-mce-style=\"font-size: 18px; line-height: 27px;\"><a style=\"text-decoration: underline;\" href=\"http://www.cakemail.com\" target=\"_blank\" rel=\"noopener\">${translations.linksLink}</a></span></li>\n</ul>\n</div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 18px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\">\n<ul style=\"list-style-type: circle;\">\n<li style=\"font-size: 14px; line-height: 21px; word-break: break-word;\" data-mce-style=\"font-size: 14px; line-height: 21px; word-break: break-word;\"><span style=\"font-size: 18px; line-height: 27px;\" data-mce-style=\"font-size: 18px; line-height: 27px;\"><a style=\"text-decoration: underline;\" href=\"http://www.cakemail.com\" target=\"_blank\" rel=\"noopener\">${translations.linksLink}</a></span></li>\n</ul>\n</div>`,
                                            style: {
                                                color: "#4a4a4a",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "30px",
                                "padding-right": "30px",
                                "padding-top": "0px",
                            },
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#000000",
                            width: "500px",
                        },
                    },
                    type: "one-column-empty",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top": "1px solid #E2E2E2",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "60px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "60px",
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-divider",
                                },
                                {
                                    descriptor: {
                                        computedStyle: { hideContentOnMobile: false },
                                        style: {
                                            "padding-bottom": "24px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#009370" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"line-height: 21px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 21px; font-size: 12px; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\"><p style=\"line-height: 21px; word-break: break-word; text-align: center; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"line-height: 21px; word-break: break-word; text-align: center;\"><span style=\"font-size: 22px; line-height: 39px;\" data-mce-style=\"font-size: 22px; line-height: 39px;\">${translations.socialHeader}</span></p></div>`,
                                            style: {
                                                color: "#bbbbbb",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "180%",
                                            },
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            height: 57,
                                            hideContentOnMobile: false,
                                            iconsDefaultWidth: 32,
                                            padding: "0 10px 0 10px",
                                            width: 151,
                                        },
                                        iconsList: {
                                            icons: [
                                                {
                                                    image: {
                                                        alt: "Facebook",
                                                        href: "https://www.facebook.com/",
                                                        prefix: "https://www.facebook.com/",
                                                        src: "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-outline-circle-default-gray/facebook@2x.png",
                                                        title: "Facebook",
                                                    },
                                                    name: "Facebook",
                                                    text: "",
                                                    type: "follow",
                                                },
                                                {
                                                    image: {
                                                        alt: "Twitter",
                                                        href: "https://twitter.com/",
                                                        prefix: "https://twitter.com/",
                                                        src: "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-outline-circle-default-gray/twitter@2x.png",
                                                        title: "Twitter",
                                                    },
                                                    name: "Twitter",
                                                    text: "",
                                                    type: "follow",
                                                },
                                                {
                                                    image: {
                                                        alt: "Instagram",
                                                        href: "https://instagram.com/",
                                                        prefix: "https://instagram.com/",
                                                        src: "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-outline-circle-default-gray/instagram@2x.png",
                                                        title: "Instagram",
                                                    },
                                                    name: "Instagram",
                                                    text: "",
                                                    type: "follow",
                                                },
                                                {
                                                    image: {
                                                        alt: "LinkedIn",
                                                        href: "https://www.linkedin.com/",
                                                        prefix: "https://www.linkedin.com/",
                                                        src: "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-outline-circle-default-gray/linkedin@2x.png",
                                                        title: "LinkedIn",
                                                    },
                                                    name: "LinkedIn",
                                                    text: "",
                                                    type: "follow",
                                                },
                                            ],
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "text-align": "center",
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-social",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top": "1px solid #E2E2E2",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "32px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "60px",
                                        },
                                    },
                                    type: "mailup-bee-newsletter-modules-divider",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px",
                            },
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#000000",
                            width: "500px",
                        },
                    },
                    type: "one-column-empty",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            class: "center fixedwidth",
                                            width: "108px",
                                        },
                                        image: {
                                            alt: "Alternate text",
                                            height: "182px",
                                            href: "",
                                            src: "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/d12425a2-57e5-445b-896d-425ad79fd2ca/851575/cakemail-demo-content-logo%403x.png",
                                            width: "363px",
                                        },
                                        style: {
                                            "padding-bottom": "32px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            width: "100%",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-image",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnDesktop: false,
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#9b9b9b" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif; font-size: 12px; line-height: 18px;\" data-mce-style=\"font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif; font-size: 12px; line-height: 18px;\"><p style=\"font-size: 18px; line-height: 27px; text-align: center; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 18px; line-height: 27px; text-align: center; word-break: break-word;\"><span style=\"font-size: 12px; line-height: 18px;\" data-mce-style=\"font-size: 12px; line-height: 18px;\">[CLIENTS.COMPANY_NAME], [CLIENTS.ADDRESS1], </span><span style=\"font-size: 12px; line-height: 18px;\" data-mce-style=\"font-size: 12px; line-height: 18px;\">[CLIENTS.ADDRESS2], [CLIENTS.CITY], [CLIENTS.PROVINCE], [CLIENTS.COUNTRY],  </span><span style=\"font-size: 12px; line-height: 18px;\" data-mce-style=\"font-size: 12px; line-height: 18px;\">[CLIENTS.POSTAL_CODE], [CLIENTS.PHONE]</span></p><p style=\"font-size: 18px; line-height: 27px; text-align: center; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 18px; line-height: 27px; text-align: center; word-break: break-word;\">\u00a0</p><p style=\"font-size: 18px; line-height: 27px; text-align: center; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 18px; line-height: 27px; text-align: center; word-break: break-word;\"><span style=\"font-size: 12px; line-height: 18px;\" data-mce-style=\"font-size: 12px; line-height: 18px;\">${translations.footer4} <a style=\"text-decoration: underline;\" href=\"${translations.footer5}\" target=\"_blank\" rel=\"noopener\">${translations.footer5}</a>.</span></p></div>`,
                                            style: {
                                                color: "#9b9b9b",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnDesktop: false,
                                            hideContentOnMobile: true,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#9b9b9b" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif; font-size: 12px; line-height: 21px;\" data-mce-style=\"font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif; font-size: 12px; line-height: 21px;\"><p style=\"font-size: 14px; line-height: 25px; text-align: center; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 25px; text-align: center; word-break: break-word;\"><span style=\"font-size: 12px; line-height: 21px;\" data-mce-style=\"font-size: 12px; line-height: 21px;\"><a style=\"text-decoration: underline;\" title=\"${translations.footerLink1}\" href=\"[SHOWEMAIL]\" target=\"_blank\" rel=\"noopener\">${translations.footerLink1}</a>\u00a0 \u00a0\u00a0<a style=\"text-decoration: underline;\" title=\"${translations.footerLink1}\" href=\"[UNSUBSCRIBE]\" target=\"_blank\" rel=\"noopener\">${translations.footerLink2}</a> \u00a0\u00a0 <a style=\"text-decoration: underline;\" title=\"${translations.footerLink3}\" href=\"[GLOBAL_UNSUBSCRIBE]\" target=\"_blank\" rel=\"noopener\">${translations.footerLink3}</a></span></p></div>`,
                                            style: {
                                                color: "#9b9b9b",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "180%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnDesktop: true,
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                        },
                                        text: {
                                            computedStyle: { linkColor: "#9b9b9b" },
                                            html: `<div class=\"txtTinyMce-wrapper\" style=\"font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif; font-size: 12px; line-height: 18px;\" data-mce-style=\"font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif; font-size: 12px; line-height: 18px;\"><p style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word;\"><span style=\"font-size: 12px; line-height: 18px;\" data-mce-style=\"font-size: 12px; line-height: 18px;\"><a style=\"text-decoration: underline;\" title=\"${translations.footerLink1}\" href=\"[SHOWEMAIL]\" target=\"_blank\" rel=\"noopener\">${translations.footerLink1}</a></span></p><p style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word;\">\u00a0</p><p style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word;\"><span style=\"font-size: 12px; line-height: 18px;\" data-mce-style=\"font-size: 12px; line-height: 18px;\"><a style=\"text-decoration: underline;\" title=\"${translations.footerLink2}\" href=\"[UNSUBSCRIBE]\" target=\"_blank\" rel=\"noopener\">${translations.footerLink2}</a></span></p><p style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word;\">\u00a0</p><p style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word; font-family: Arial, &apos;Helvetica Neue&apos;, Helvetica, sans-serif;\" data-mce-style=\"font-size: 14px; line-height: 21px; text-align: center; word-break: break-word;\"><span style=\"font-size: 12px; line-height: 18px;\" data-mce-style=\"font-size: 12px; line-height: 18px;\"><a style=\"text-decoration: underline;\" title=\"${translations.footerLink3}\" href=\"[GLOBAL_UNSUBSCRIBE]\" target=\"_blank\" rel=\"noopener\">${translations.footerLink3}</a></span></p></div>`,
                                            style: {
                                                color: "#9b9b9b",
                                                "font-family":
                                                    "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "60px",
                                "padding-left": "30px",
                                "padding-right": "30px",
                                "padding-top": "60px",
                            },
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#333",
                            width: "600px",
                        },
                    },
                    locked: false,
                    type: "one-column-empty",
                },
            ],
            template: { name: "template-base", type: "basic", version: "2.0.0" },
            title: "",
        },
    }
}